import { render } from "./ServicePublic.vue?vue&type=template&id=2e246b5b&ts=true"
import script from "./ServicePublic.vue?vue&type=script&lang=ts"
export * from "./ServicePublic.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__